<template>
  <main class="page">
    <AppBack/>

    <AppPageHeader
      :title="isCreate ? 'Создать водителя' : 'Редактировать водителя'"
    />

    <div class="form__bg">
      <div class="form__inputs">
        <AppInput title="ФИО"
                  required
                  :value="driver.full_name"
                  :valid="validation.full_name"
                  @value-changed="setFullName"
                  @got-focus="clearValidation('full_name')"
        />

        <AppInput title="Телефон"
                  :value="driver.phone"
                  :valid="validation.phone"
                  @value-changed="setPhone"
                  @got-focus="clearValidation('phone')"
                  mask="7##########"
        />
      </div>

      <AppInputFile
        :value="driver.passports"
        title="Паспорт (сканы)"
        class="mb-30"
        name="passports"
        @value-changed="setPassports"
        @delete-file="addPassportFileToDelete"
      />

      <AppInputFile
        :value="driver.drivers_license"
        title="Водительские права (сканы)"
        class="mb-30"
        name="drivers_license"
        @value-changed="setDriversLicense"
        @delete-file="addDriverLicenseFileToDelete"
      />

      <div class="form__inputs form__inputs_col-1">
        <AppTextarea title="Комментарий"
                     :value="driver.comment"
                     @value-changed="setComment"
        />
      </div>

      <div class="form__inputs mb-40">
        <VSelect
          label="Транспорт по умолчанию"
          v-model="driver.default_car"
          :items="driver.transport"
        />

        <VSelect
          label="Транспорт"
          name="transport"
          v-model="driver.transport"
          :items="transportList"
          :handler-search="GETLogisticTransportList"
          search
          multiple
        />
      </div>

      <div class="d-flex gap-16">
        <AppButton
          :title="isCreate ? 'Создать' : 'Сохранить'"
          type="main"
          @click.native="saveDriverInfo"
        />

        <AppButton
          title="Отмена"
          type="alt"
          @click.prevent.native="leavePage"
        />
      </div>
    </div>

    <ThePagePreloader v-if="isLoading && !isCreate"/>
  </main>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import AppPageHeader from '@/components/page/AppPageHeader'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppInput from '@/components/page/input/AppInput'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppInputFile from '@/components/page/input/AppInputFile'
import AppBack from '@/components/page/AppBack'
import VSelect from '@/components/page/Form/VSelect'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'LogisticDriverUpdate',
  components: {
    VSelect,
    AppPageHeader,
    AppInputFile,
    AppTextarea,
    AppInput,
    AppButton,
    ThePagePreloader,
    AppBack
  },
  data: () => ({
    isCreate: false
  }),
  computed: {
    ...mapGetters('handbook/logistic', {
      transportList: 'transportList'
    }),
    ...mapState('logistic/driverUpdate', {
      driver: 'driver',
      validation: 'validation',
      isLoading: 'isLoading'
    })
  },

  watch: {
    'driver.transport' (val) {
      if (!val?.length) {
        return this.SET_DRIVER_UPDATE_DEFAULT_CAR(null)
      }

      if (this.driver.default_car) return

      this.SET_DRIVER_UPDATE_DEFAULT_CAR(val[0])
    }
  },

  mounted () {
    const id = this.$router.history.current.params.id

    this.setInitialState()

    if (id === 'create') {
      this.isCreate = true
    } else {
      this.loadItem(id)
      this.isCreate = false
    }

    this.GETLogisticTransportList()
  },

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapActions('handbook/logistic', {
      GETLogisticTransportList: 'GETLogisticTransportList'
    }),

    ...mapMutations('logistic/driverUpdate', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE',
      setFullName: 'SET_DRIVER_UPDATE_FULL_NAME',
      setPhone: 'SET_DRIVER_UPDATE_PHONE',
      setComment: 'SET_DRIVER_UPDATE_COMMENT',
      SET_DRIVER_UPDATE_DEFAULT_CAR: 'SET_DRIVER_UPDATE_DEFAULT_CAR',
      clearValidation: 'CLEAR_DRIVER_UPDATE_VALIDATION',
      setPassports: 'SET_DRIVER_UPDATE_PASSPORTS',
      setDriversLicense: 'SET_DRIVER_UPDATE_DRIVERS_LICENSE',
      setInitialState: 'SET_DRIVER_UPDATE_INITIAL_STATE'
    }),

    ...mapActions('logistic/driverUpdate', {
      saveDriverInfo: 'saveDriverUpdate',
      loadItem: 'getDriverUpdate',
      addPassportFileToDelete: 'addPassportFileToDelete',
      addDriverLicenseFileToDelete: 'addDriverLicenseFileToDelete'
    }),

    leavePage () {
      this.$router.push({ name: 'LogisticDriverList' })
    }
  }
}
</script>
